import React from 'react';
import { useWallet } from '../../context/WalletContext';

const WrongNetworkBanner = () => {
  const { account, isRightNetwork, switchNetwork, activeChain } = useWallet();
  if (!account || isRightNetwork) return null;
  return (
    <div className="wrong-network">
      <span>⚠ Wrong network detected — please switch to {activeChain.name}.</span>
      <button onClick={switchNetwork}>Switch Network</button>
    </div>
  );
};

export default WrongNetworkBanner;
